import DashboardTopContainer from './DashboardTopContainer.js';

export default DashboardTopContainer;